import { ComponentMeta, ComponentStory } from "@storybook/react";
import { AlarmCheck } from "lucide-react";
import React from "react";
import { MemoryRouter } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";

const commonArgs: React.ComponentProps<typeof Breadcrumbs> = {
    breadcrumbs: [
        {
            title: "Page A",
            to: "/page"
        },
        {
            title: "Page B"
        }
    ]
};

export default {
    title: "Layout/Breadcrumbs",
    component: Breadcrumbs,
    args: commonArgs
} as ComponentMeta<typeof Breadcrumbs>;

const Template: ComponentStory<typeof Breadcrumbs> = args => {
    return (
        <MemoryRouter initialEntries={["/"]}>
            <div style={{ width: "200px" }}>
                <Breadcrumbs {...args} />
            </div>
        </MemoryRouter>
    );
};

export const Default = Template.bind({});

export const WithBetaTag = Template.bind({});
WithBetaTag.args = {
    breadcrumbs: [
        {
            title: "Page A",
            to: "/page"
        },
        {
            title: "Page B",
            isBeta: true
        }
    ]
};

export const WithIcon = Template.bind({});
WithIcon.args = {
    breadcrumbs: [
        {
            title: "Page A",
            to: "/page"
        },
        {
            title: "Page B",
            icon: <AlarmCheck />
        }
    ]
};

export const WithSingleItem = Template.bind({});
WithSingleItem.args = {
    breadcrumbs: [
        {
            title: "Page A"
        }
    ]
};
